let isLoading = false
let loadingEle = null
let toastBody = null

let server = null
import axios from "axios";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import moment from 'moment-timezone';

const urlList = [
	'https://rev0.khljbzxpeytzgsqgtfki.cc',
	'https://rev1.khljbzxpeytzgsqgtfki.cc',
	'https://rev0.nebulabinaryproxy.win',
	'https://rev1.nebulabinaryproxy.win',
	'https://rev0.goalphacloud.com',
	'https://rev1.goalphacloud.com',
]

async function getServerUrl(index = 0) {
	if (server) {
		return
	}

	showLoading()

	try {
		const url = urlList[index]
		const result = await getRequestAsync(url + '/web/test', true)
		if (result?.ok === true) {
			const text = await result.text()
			server = url
		} else if (index + 1 < urlList.length) {
			const newIndex = index + 1
			await getServerUrl(newIndex)
		}
	} finally {
		hideLoading()
	}

}

function convertTimestampToTimeString(timestamp) {
	// 使用moment-timezone将时间戳转换为"Asia/Shanghai"时区的时间
	// 并格式化为常见的日期时间格式
	return moment(timestamp * 1000).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss');
}

// 指纹缓存：同一浏览器的 visitorId 是恒定值，整个会话只需计算一次。
// 缓存的是 promise 而非结果，天然对并发调用去重（多个请求共享同一次计算）。
let fpPromise = null

async function getFingerprint() {
	if (!fpPromise) {
		fpPromise = (async () => {
			try {
				const fp = await FingerprintJS.load({screen_resolution: true})
				const result = await fp.get()
				return result.visitorId
			} catch (e) {
				// 计算失败不缓存失败结果，下次调用可重试
				fpPromise = null
				throw e
			}
		})()
	}
	return fpPromise
}

function showToast(text) {

	if (toastBody) {
		document.body.removeChild(toastBody)
		toastBody = null
	}
	toastBody = document.createElement("div");
	toastBody.classList.add('sl-toast');
	toastBody.innerText = text
	document.body.append(toastBody)
	const timeoutID = window.setTimeout(() => {
		if (toastBody) {
			document.body.removeChild(toastBody)
			toastBody = null
		}
		window.clearTimeout(timeoutID)
	}, 3000);
}

// 请求默认超时时间（ms）。挂起的请求会被 AbortController 强制中断，避免 UI 卡死。
const REQUEST_TIMEOUT = 15000

// 构造通用请求头。注意：不再设置 "Connection: keep-alive"，它是 fetch 的禁止头，浏览器会忽略。
async function buildRequestHeaders() {
	const headers = new Headers()
	headers.append("Content-Type", "application/json")
	headers.append("Accept", "*/*")
	const fp = await getFingerprint()
	headers.append("fp", fp)
	const sessionId = localStorage.getItem('sessionId')
	if (sessionId) {
		headers.append("sessionid", sessionId)
	}
	// 禁用缓存
	headers.append("Cache-Control", "no-cache")
	headers.append("Pragma", "no-cache")
	headers.append("Expires", "0")
	return headers
}

// 带超时的 fetch：超时后主动 abort，无论成功失败都清掉定时器。
function fetchWithAbort(url, options, timeout = REQUEST_TIMEOUT) {
	const controller = new AbortController()
	const timer = setTimeout(() => controller.abort(), timeout)
	return fetch(url, {...options, signal: controller.signal}).finally(() => clearTimeout(timer))
}

// 候选服务器列表：当前选中的 server 排在最前，其余备用节点依次跟随。
// 用于在当前节点网络故障时自动切换到下一个可用节点。
function getServerCandidates() {
	const candidates = []
	if (server) {
		candidates.push(server)
	}
	for (const url of urlList) {
		if (url !== server) {
			candidates.push(url)
		}
	}
	return candidates
}

// 按活动续期：任一业务请求成功往返后刷新本地空闲计时，
// 与后端"每次校验都滑动续期 lastLoginTimestamp"保持一致——只要在用就不会因空闲到期。
// 仅在本地存在 sessionId 时续期；真正会话是否有效仍由服务端校验兜底。
function touchSession() {
	if (localStorage.getItem('sessionId')) {
		localStorage.setItem('lastLoginTime', Date.now().toString())
	}
}

// 安全解析 JSON：节点返回 502/HTML 等非 JSON 内容时不抛异常，返回 null。
async function safeParseJson(response) {
	try {
		return await response.json()
	} catch (e) {
		return null
	}
}

// GET 专用「超时 + 故障转移」：GET 幂等，可安全地依次尝试候选节点。
// 网络层错误（断连/超时）才切换下一个；只要拿到 HTTP 响应（含 4xx/5xx）就认为节点可达并返回。
async function getWithFailover(path, options) {
	const candidates = getServerCandidates()
	for (const base of candidates) {
		try {
			const response = await fetchWithAbort(`${base}/${path}`, options)
			// 该节点可达，记住它作为后续请求的首选节点
			server = base
			return await safeParseJson(response)
		} catch (e) {
			// 网络层错误（含超时 abort），尝试下一个候选节点
		}
	}
	// 所有候选节点均失败，让当前节点失效以便下次重新探测；
	// 返回 null（而非抛异常），调用方按 result?.code 判断即可优雅降级，不会卡住 loading。
	server = null
	return null
}

// POST 专用「超时 + 单节点」：POST 通常有副作用（提现/回复/提交工单等），
// 跨节点重试可能导致重复提交，因此只请求当前节点，不做故障转移。
// 网络层失败返回 null（与全 URL 模式一致），避免异常冒泡卡住调用方的 loading 状态。
async function postSingle(path, options, timeout = REQUEST_TIMEOUT) {
	if (!server) {
		// server 尚未解析时先探测一次，避免请求到 "null/path"
		await getServerUrl()
	}
	try {
		const response = await fetchWithAbort(`${server}/${path}`, options, timeout)
		return await safeParseJson(response)
	} catch (e) {
		return null
	}
}

async function getRequestAsync(url, isFullUrl = false) {
	const headers = await buildRequestHeaders()
	const requestOptions = {
		method: 'GET',
		headers: headers,
		redirect: 'follow'
	}

	if (isFullUrl === true) {
		// 全 URL 模式保持原行为：返回原始 Response 交给调用方处理
		return await fetchWithAbort(url, requestOptions)
	} else {
		const result = await getWithFailover(url, requestOptions)
		// 成功与后端往返（拿到响应）即视为一次活动，续期本地空闲计时
		if (result) {
			touchSession()
		}
		return result
	}
}

// timeout：个别接口服务端要现查外部存储，默认的 15s 不够用，由调用方单独放宽
async function postRequestAsync(url, data, isFullUrl = false, timeout = REQUEST_TIMEOUT) {
	const headers = await buildRequestHeaders()
	const raw = JSON.stringify(data)
	const requestOptions = {
		method: 'POST',
		headers: headers,
		body: raw,
		redirect: 'follow'
	}

	if (isFullUrl === true) {
		try {
			return await fetchWithAbort(url, requestOptions, timeout)
		} catch (e) {
			return null
		}
	} else {
		const result = await postSingle(url, requestOptions, timeout)
		// 成功与后端往返（拿到响应）即视为一次活动，续期本地空闲计时
		if (result) {
			touchSession()
		}
		return result
	}
}

function showLoading() {
	if (isLoading === false) {
		const loadingContainer = document.createElement("div")
		loadingContainer.classList.add('loader-container')
		let loadingBody = document.createElement("div")
		loadingBody.classList.add('loader');
		loadingContainer.append(loadingBody)
		// toastBody.innerText = text
		document.body.append(loadingContainer)
		isLoading = true
		loadingEle = loadingContainer
	}

}

function hideLoading() {
	if (loadingEle) {
		document.body.removeChild(loadingEle)
		isLoading = false
		loadingEle = null
	}
}

let clickTimer = {}

function clickThrottle(clickType = 'default', interval = 3000) {
	let now = Date.now()
	if (!clickTimer[clickType]) {
		clickTimer[clickType] = 0
	}
	let lastClicked = clickTimer[clickType]
	if (now - lastClicked < interval) {
		return false
	} else {
		clickTimer[clickType] = now;
		return true
	}
}

function verifyEmail(email) {
	// const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
	const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (email.value === "") {
		return false;
	}
	return reg.test(email);
}

function isMobile() {
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		return true
	}
	return false
}

function fallbackCopyTextToClipboard(text) {
	let textArea = document.createElement("textarea");
	textArea.value = text;

	// Avoid scrolling to bottom
	textArea.style.top = "0";
	textArea.style.left = "0";
	textArea.style.position = "fixed";


	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();
	let toReturn = ''
	try {
		let successful = document.execCommand('copy');
		toReturn = successful ? 'success' : 'fail'
	} catch (err) {
		toReturn = 'fail'
	}

	document.body.removeChild(textArea);
	return toReturn
}

/**
 * 复制文本到剪贴板，返回是否成功。
 *
 * navigator.clipboard 只在安全上下文（https 或 localhost）下可用，而后台面板
 * 经常是 http + IP 直连，那里拿不到这个 API——所以必须保留 execCommand 这条降级路径。
 */
async function copyToClipboard(text) {
	if (!text) {
		return false
	}
	if (navigator.clipboard && window.isSecureContext) {
		try {
			await navigator.clipboard.writeText(text)
			return true
		} catch (e) {
			// 权限被拒 / 非用户手势触发等，继续走下面的降级方案
		}
	}
	return fallbackCopyTextToClipboard(text) === 'success'
}

function startDownload(url) {
	let a = document.createElement('a');
	a.setAttribute('download', '');// download属性
	a.setAttribute('href', url);// href链接
	a.click();// 自执行点击事件
	a = null;
}

function formatDateString(timestamp) {
	const date = new Date(timestamp * 1000);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	return `${year}年${month}月${day}日 ${hours}:${minutes}`;
}

function isValidTRC20Address(address) {
	const trc20AddressRegex = /^(T|t)[A-Za-z0-9]{33}$/;

	return trc20AddressRegex.test(address);
}

function isValidBEP20Address(address) {
	const bep20AddressRegex = /^(0x)?[A-Fa-f0-9]{40}$/;

	return bep20AddressRegex.test(address);
}

function roundNumber(number, decimals = 2) {
	return (number / 100).toFixed(decimals)
}

function extractDomain(url) {
	// 如果没有协议头，添加临时协议头以便使用 URL API
	if (!/^https?:\/\//i.test(url)) {
		url = 'https://' + url;
	}

	try {
		const domain = new URL(url).hostname;
		return domain.replace(/^www\./i, ''); // 移除 www. 前缀
	} catch {
		return null;
	}
}

function visitClassifyByUrl(list) {

	const classifiedDomain = {}
	for (const item of list) {
		const extractedDomain = extractDomain(item.url)
		if (!classifiedDomain[extractedDomain]) {
			classifiedDomain[extractedDomain] = {}
			classifiedDomain[extractedDomain][item.deviceType] = 1
			classifiedDomain[extractedDomain].count = 1

		} else {
			if (classifiedDomain[extractedDomain][item.deviceType]) {
				classifiedDomain[extractedDomain][item.deviceType]++
			} else {
				classifiedDomain[extractedDomain][item.deviceType] = 1
			}

			classifiedDomain[extractedDomain].count++
		}

	}
	return Object.entries(classifiedDomain).map(([tag, data]) => ({
		tag,
		count: data.count || 0,
		android: data.android || 0,
		windows: data.windows || 0,
		mac: data.mac || 0,
		ios: data.ios || 0
	})).sort((a, b) => b.count - a.count);
}


function generateDownloadType(list) {
	let android = 0, ios = 0, mac = 0, windows = 0
	for (const item of list) {
		if (item.actionType.indexOf('android') >= 0) {
			android++
		}
		if (item.actionType.indexOf('ios') >= 0) {
			ios++
		}
		if (item.actionType.indexOf('mac') >= 0) {
			mac++
		}
		if (item.actionType.indexOf('windows') >= 0) {
			windows++
		}
	}

	return {android, ios, mac, windows}

}

function generateDeviceType(list) {
	let android = 0, ios = 0, mac = 0, windows = 0
	for (const item of list) {
		if (item.deviceType?.indexOf('android') >= 0) {
			android++
		}
		if (item.deviceType?.indexOf('ios') >= 0) {
			ios++
		}
		if (item.deviceType?.indexOf('mac') >= 0) {
			mac++
		}
		if (item.deviceType?.indexOf('windows') >= 0) {
			windows++
		}
	}

	return {android, ios, mac, windows}

}

function registerListClassifyByReferCode(list) {
	if (!Array.isArray(list) || list?.length === 0) {
		return []
	}
	const toReturn = []
	for (const item of list) {
		const record = toReturn.find(record => record.referCode === item.referCode)
		if (record) {
			record.count++
		} else {
			toReturn.push({
				referCode: item.referCode,
				count: 1,
			})
		}


	}
	return toReturn.sort((a, b) => b.count - a.count).slice(0, 6)
}

function paymentRecordsClassifiedByReferCode(paymentRecords) {

	const toReturn = []

	for (const item of paymentRecords) {
		if (item.referCode) {
			const record = toReturn.find(a =>
				a.referCode === item.referCode
			)
			if (record) {
				record.count++
				record.amount += parseInt(item.amount) / 100
			} else {
				console.log(`referCode: ${item.referCode}`)
				toReturn.push({
					referCode: item.referCode,
					count: 1,
					amount: parseInt(item.amount) / 100
				})
			}
		}
	}

	return toReturn.sort((a, b) => {
		if (b.count === a.count) {
			return b.amount - a.amount
		}
		return b.count - a.count
	})

}

async function getSubscriptionPlans() {
	showLoading()
	const result = await getRequestAsync('airport/subPlans/getSubscribePlans')
	hideLoading()
	return {err: false, result}
}

async function reportVisit(actionType = 'web_visit_login') {
	const url = window.location.href;
	const fingerprint = await getFingerprint()
	await postRequestAsync('web/reportAirportVisit', {url, fingerprint, actionType})
}

async function uploadFile(url, formData, uploadProgress, uploadSuccess, uploadFail) {
	const sessionId = localStorage.getItem('sessionId');
	if (!sessionId) {
		return
	}
	// admin 路由和 postRequestAsync 一样靠 fp + sessionid 鉴权，少了 fp 会被当成未登录（201）
	const fp = await getFingerprint()
	showLoading()
	axios.post(`${server}/${url}`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
			'sessionid': sessionId,
			'fp': fp
		},
		onUploadProgress: function (progressEvent) {
			// 计算上传进度的百分比
			const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
			uploadProgress(percentCompleted)
			// console.log(`Upload progress: ${percentCompleted}%`);
			// 你可以在这里根据百分比来更新UI，例如进度条或者状态信息
		}
	}).then(response => {
		uploadSuccess(response.data)
	})
		.catch(error => {
			uploadFail()
		}).finally(() => {
		hideLoading()
	});
}

async function submitTicket(ticketSubject, ticketContent, ticketType, ticketId) {
	showLoading()
	const result = await postRequestAsync('airport/ticket/submitTicket', {
		ticketSubject,
		ticketContent,
		ticketType,
		ticketId
	})
	hideLoading()
	return {err: false, result}
}

async function getSubmittedTickets() {
	showLoading()
	const result = await getRequestAsync('airport/ticket/getSubmittedTicket')
	hideLoading()
	return {err: false, result}
}

async function getDividendInfo() {
	showLoading()
	const result = await getRequestAsync('airport/reference/getAvailableDividend')
	hideLoading()
	return {err: false, result}
}

async function withdrawDividend(vcode) {
	showLoading()
	const result = await postRequestAsync('airport/reference/withdrawDividend', {vcode})
	hideLoading()
	return {err: false, result}
}

async function getWalletInfo() {
	showLoading()
	const result = await getRequestAsync('airport/reference/getReceiverAddress')
	hideLoading()
	return {err: false, result}
}

async function sendWithdrawDividendVcode() {
	showLoading()
	const result = await getRequestAsync('airport/reference/sendWithdrawDividendVcode')
	hideLoading()
	return {err: false, result}
}

function getCurrentUrl() {
	return window.location.href
}

/**
 * 当前已探测到的服务端地址（形如 https://rev0.xxx.cc）。
 * 尚未探测时先探一次，供 WebSocket 之类不走 postSingle 的调用方拼地址用。
 */
async function getServerBase() {
	if (!server) {
		await getServerUrl()
	}
	return server
}

// 最大空闲时长：30 天。需与后端 AdminSessionModel 的 expiredInSeconds 保持一致。
const SESSION_MAX_IDLE_MS = 30 * 24 * 60 * 60 * 1000
// 后端明确判定"未登录/会话无效/已过期"的业务码：201(缺凭证) / 300(无会话) / 301(已过期)。
// 只有收到这些码才真正登出；网络故障等其它情况不应删除本地凭证。
const AUTH_REJECTED_CODES = [201, 300, 301]

function clearLocalSession() {
	localStorage.removeItem('lastLoginTime')
	localStorage.removeItem('sessionId')
}

async function verifyFp() {
	const sessionId = localStorage.getItem('sessionId')
	const lastLoginTime = parseInt(localStorage.getItem('lastLoginTime') || '0', 10)

	// 本地无凭证，或本地空闲已超过最大时长 —— 直接判定未登录
	if (!sessionId || !lastLoginTime || Date.now() - lastLoginTime > SESSION_MAX_IDLE_MS) {
		clearLocalSession()
		return false
	}

	let response
	showLoading()
	try {
		response = await getRequestAsync('admin/auth/verifyFp')
	} catch (e) {
		response = null
	} finally {
		hideLoading()
	}

	// 后端明确拒绝（会话无效/过期）—— 清除本地凭证，要求重新登录
	if (response && AUTH_REJECTED_CODES.includes(response.code)) {
		clearLocalSession()
		return false
	}

	// 后端确认有效 —— 刷新本地空闲计时，与服务端的滑动过期保持同步，
	// 避免"自首次登录起满 7 天即强制登出"的问题
	if (response?.code === 200) {
		localStorage.setItem('lastLoginTime', Date.now().toString())
		return true
	}

	// 其它情况（网络超时 / 无响应 / 节点全部不可达）：
	// 本地凭证仍在有效期内，不删除凭证、放行进入。
	// 真正的鉴权由后续每个业务接口的服务端校验兜底，绝不会因一次网络抖动把用户踢下线。
	return true
}

function fetchWithTimeout(url, options, timeout = 5000) {
	return Promise.race([
		fetch(url, options),
		new Promise((_, reject) =>
			setTimeout(() => reject(new Error('Request timeout')), timeout)
		)
	]);
}

export {
	showToast,
	showLoading,
	hideLoading,
	verifyEmail,
	startDownload,
	copyToClipboard,
	clickThrottle,
	formatDateString,
	isValidTRC20Address,
	isValidBEP20Address,
	roundNumber,
	postRequestAsync,
	getRequestAsync,
	visitClassifyByUrl,
	registerListClassifyByReferCode,
	generateDownloadType,
	generateDeviceType,
	paymentRecordsClassifiedByReferCode,
	getSubscriptionPlans,
	reportVisit,
	uploadFile,
	submitTicket,
	getSubmittedTickets,
	convertTimestampToTimeString,
	getDividendInfo,
	withdrawDividend,
	getWalletInfo,
	sendWithdrawDividendVcode,
	getCurrentUrl,
	getServerUrl,
	getServerBase,
	getFingerprint,
	verifyFp,
	fetchWithTimeout
}